<template>
    <div class="app-header bg-zinc-800 min-h-[72px] h-[72px]">
        <layout-contained class="h-full">
            <div class="h-full flex flex-row">
                <app-header-logo class="grow lg:grow-0"></app-header-logo>
                <div class="grow"></div>
                <app-header-me v-if="isLoggedIn" class="flex px-4 py-2"></app-header-me>
                <app-header-login v-else class="hidden px-5 md:flex md:gap-x-4"></app-header-login>
                <app-drawer></app-drawer>
                <app-header-drawer class="py-2 pl-2" :unreadCount="unreadCount"></app-header-drawer>
            </div>
        </layout-contained>
    </div>
</template>

<script>
import {mapState} from 'pinia';

export default {
    name: 'AppHeader',
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        ...mapState(useStoreThreadsUnread, {
            unreadCount: 'unreadCount',
        }),
    },
};
</script>
